import { render } from "./RateTable.vue?vue&type=template&id=489cb7ba"
import script from "./RateTable.vue?vue&type=script&lang=js"
export * from "./RateTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__